import styled from 'styled-components';

export const EquipmentSelectorStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;

    .label {
        font-size: 12px;
        line-height: 20px;
        color: #8181A5;
    }

    .selector-container {
        position: relative;
        width: 100%;
    }

    .selector {
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 0px 10px;
        height: 37px;
        background: white;
        cursor: pointer;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
        justify-content: space-between;


        &.disabled {
            background: #f5f5f5;
            cursor: not-allowed;
            opacity: 0.6;
        }

        .selected-items {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            align-items: center;

            .placeholder {
                color: #e1e4ea;
                font-weight: 500;
                line-height: normal;
                font-size: 14px;
            }

            .selected-equipment {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;

                .equipment-tag {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 12px;

                    .equipment-photo {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        object-fit: cover;
                        
                    }
                    .equipment-photo-placeholder {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        background-color: #E1E4EA;
                    }

                    .equipment-name {
                        font-size: 14px;
                        line-height: normal;
                        font-weight: 500;
                    }

                    .equipment-count {
                        font-size: 12px;
                        color: #666;
                        font-weight: 500;
                    }

                    .remove-btn {
                        background: none;
                        border: none;
                        color: #666;
                        cursor: pointer;
                        font-size: 16px;
                        line-height: 1;
                        padding: 0;
                        width: 16px;
                        height: 16px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 50%;

                        &:hover {
                            background: #f5f5f5;
                            color: #333;
                        }
                    }
                }
            }
        }

        .arrow {
            color: #666;
            font-size: 12px;
            transition: transform 0.2s ease;
        }

        &.open .arrow {
            transform: rotate(180deg);
        }
    }

    .dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        border: 1px solid #ddd;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 1000;
        max-height: 300px;
        overflow-y: auto;
        margin-top: 4px;

        .loading {
            padding: 20px;
            text-align: center;
            color: #666;
        }

        .equipment-list {
            .equipment-item {
                display: flex;
                align-items: center;
                gap: 12px;
                padding: 12px;
                cursor: pointer;
                border-bottom: 1px solid #f0f0f0;
                transition: background-color 0.2s ease;

                &:last-child {
                    border-bottom: none;
                }

                &:hover {
                    background: #f8f9fa;
                }

                &.selected {
                    background: #e3f2fd;
                }

                .equipment-photo {
                    width: 40px;
                    height: 40px;
                    border-radius: 6px;
                    object-fit: cover;
                    flex-shrink: 0;
                }

                .equipment-info {
                    flex: 1;
                    min-width: 0;

                    .equipment-name {
                        font-weight: 500;
                        color: #333;
                        margin-bottom: 2px;
                    }

                    .equipment-code {
                        font-size: 12px;
                        color: #666;
                        margin-bottom: 2px;
                    }

                    .equipment-count {
                        font-size: 12px;
                        color: #28a745;
                    }
                }

                .selection-indicator {
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #007bff;
                    font-weight: bold;
                    flex-shrink: 0;
                }
            }
        }

        .load-more {
            padding: 12px;
            text-align: center;
            border-top: 1px solid #f0f0f0;

            .load-more-btn {
                background: #007bff;
                color: white;
                border: none;
                border-radius: 6px;
                padding: 8px 16px;
                cursor: pointer;
                font-size: 14px;
                transition: background-color 0.2s ease;

                &:hover:not(:disabled) {
                    background: #0056b3;
                }

                &:disabled {
                    background: #ccc;
                    cursor: not-allowed;
                }
            }
        }
    }
`;

